.color_selector {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 8px;
  row-gap: 8px;
  align-items: start;

  min-height: 51px;
  @media (max-width: 499px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    min-height: 41px;
  }
}
.payment_terms {
  font-size: 12px;
  text-align: center;
  margin-top: 15px;
}

.skeleton_wrapper {
  display: contents;
}

.shipping_estimate {
  margin-top: 12px;
  font-size: 13px;
  text-align: center;
  color: #1a1a1a;
}

.shipping_estimate_prompt {
  margin-top: 12px;
  font-size: 13px;
  text-align: left;
  color: #1a1a1a;
  font-weight: 400;
}

.shipping_estimate_prompt_highlight {
  color: #c0392b;
  font-weight: 700;
}

.vehicle_video_link {
  display: block;
  margin-top: 10px;
  padding: 0;
  background: none;
  border: none;
  color: #ed1b34;
  text-decoration: underline;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  line-height: 1.3;

  &:hover {
    color: #c41528;
  }
}

.skeleton {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #e0e0e0;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    animation: pulse 1.5s infinite;
  }
}

@keyframes pulse {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}